import component from '@/mixins/component'
import RAF from '@/js/utils/raf'

import WebglManager from '@/glxp/webglManager'

import { throttle, debounce } from 'lodash'
import { TweenMax } from 'gsap'
import Draggable from 'gsap/Draggable'
require('@/js/greensock/plugins/ThrowPropsPlugin')
require('@/js/greensock/plugins/SplitText')

const SPEED = 1
const DAMPING = 0.89
const OPACITY_STRENGTH = 1.2
const WHEEL_DAMPING = 1200

export default {
  name: 'slider-partner',
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    fullscreen: Boolean,
    onReady: Function
  },
  data () {
    return {
      currentIndex: 0,
      itemsActive: this.items,
      itemsTmp: [],
      webglEnabled: false,
      bgc: {
        backgroundColor: ''
      },
      draggable: undefined,
      snaps: [],
      velocity: 0,
      isDown: true,
      drag: false,
      progress: false,
      height: window.innerHeight,
      width: window.innerWidth
    }
  },
  mixins: [component],
  watch: {
    platform (val) {
      console.log(this.draggable)
      if (val === 'mobile') {
      } else {

      }
    }
  },
  mounted () {
    document.querySelector('html').classList.add('preventScroll')

    if (this.platform !== 'mobile') {
      RAF.suscribe('carrousel', this.update.bind(this))
      this.handleArrows = this.handleArrows.bind(this)
      this.handleScroll = this.handleScroll.bind(this)
      this.resize = this.resize.bind(this)

      this.$nextTick(() => {
        this.initDesktop()
      })
    } else {
      this.initMobile()
    }

    window.addEventListener('resize', this.resize)
    setTimeout(() => {
      this.$refs.titleContainer.classList.remove('hidden')
    }, 500)
    this.onReady()
  },

  beforeDestroy () {
    if (this.platform !== 'mobile') {
      RAF.unsuscribe('carrousel')
    }
    if (this.platform === 'desktop') {
      if (this.browser !== 'Microsoft Edge' && this.browser !== 'Internet Explorer') {
        this.glxp.reset()
        this.glxp = null
        WebglManager.desactivate('partners')
      }

      document.removeEventListener('keydown', this.handleArrows)
      document.removeEventListener('mousewheel', this.handleScroll)
      document.removeEventListener('DOMMouseScroll', this.handleScroll)
    }

    window.removeEventListener('resize', this.resize)
    document.querySelector('html').classList.remove('preventScroll')
  },

  methods: {
    initMobile () {
      this.calcSnaps()

      this.draggable = new Draggable(this.$refs.wrapper, {
        type: 'y',
        zIndexBoost: false,
        throwProps: true,
        edgeResistance: 0.85,
        minDuration: 1.2,
        bounds: {
          minY: 0,
          maxY: this.calcBoundsMax()
        },
        snap: {
          y: (endValue) => {
            const distances = this.snaps.map(snap => Math.abs(snap - endValue))
            let closest = distances.indexOf(Math.min.apply(Math, distances))
            if (closest > this.itemsActive.length - 1) closest = this.itemsActive.length - 1
            return this.snaps[closest]
          }
        },
        onDragStart: () => {
          this.hideTitle()
        },
        onRelease: () => {
          this.currentIndex = this.snaps.indexOf(this.draggable.endY)
          this.setTitle()
          this.setColor()
          setTimeout(() => {
            this.showTitle()
          }, 500)
        },
        onThrowComplete: () => {
        }
      })

      this.setTitle()
      this.setColor()
      this.showTitle()
    },
    initDesktop () {
      this.calcSnaps()
      this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      this.draggable = new Draggable(this.$refs.wrapper, {
        type: 'x',
        zIndexBoost: false,
        throwProps: true,
        edgeResistance: 0.85,
        minDuration: 1.2,
        bounds: {
          minX: 0,
          maxX: this.calcBoundsMax()
        },
        snap: {
          x: (endValue) => {
            const distances = this.snaps.map(snap => Math.abs(snap - endValue))
            let closest = distances.indexOf(Math.min.apply(Math, distances))
            if (closest > this.itemsActive.length - 1) closest = this.itemsActive.length - 1
            return this.snaps[closest]
          }
        },
        onDragStart: () => {
          this.hideTitle()
          this.drag = true
          if (this.glxp) this.glxp.focused = true
        },
        onRelease: () => {
          if (this.glxp) this.glxp.focused = false
          this.currentIndex = this.snaps.indexOf(this.draggable.endX)
          this.setTitle()
          this.setColor()
        },
        onThrowComplete: () => {
          this.drag = false
          this.showTitle()
        }
      })

      this.progressDraggable = new Draggable(this.$refs.cursor, {
        type: 'x',
        zIndexBoost: false,
        throwProps: true,
        throwResistance: 2500,
        bounds: {
          minX: 0,
          maxX: (this.$refs['progress-container'].offsetWidth * (this.itemsActive.length - 1) / this.itemsActive.length)
        },
        onDragStart: () => {
          this.hideTitle()
          this.progress = true
          if (this.glxp) this.glxp.focused = true
          // TweenMax.set(this.$refs.cursor, { scaleY: 1.4 })
        },
        onRelease: () => {
          if (this.glxp) this.glxp.focused = false
          // TweenMax.set(this.$refs.cursor, { scaleY: 1 })
          this.progress = false
          this.goTo(Math.min(Math.round(this.progressDraggable.endX / this.progressDraggable.maxX * this.itemsActive.length), this.itemsActive.length - 1), 0)
        }
      })

      this.setTitle()
      this.setColor()
      this.showTitle()

      if (this.platform === 'desktop' && this.browser !== 'Microsoft Edge' && this.browser !== 'Internet Explorer') {
        this.initWebgl()

        // this.$refs.wrapper.style.width = `${this.$refs.wrapper.offsetWidth}px`
        this.$refs.item.forEach((item, key) => {
          this.setTranslate(key, -this.snaps[key] - window.innerWidth * 0.25, 0)
          this.setOpacity(key, 1)
        })

        document.addEventListener('keydown', this.handleArrows)
        document.addEventListener('mousewheel', this.handleScroll)
        document.addEventListener('DOMMouseScroll', this.handleScroll)
      }
    },
    handleArrows (e) {
      switch (e.keyCode) {
        case 37:
        case 38:
          this.prev()
          break
        case 39:
        case 40:
          this.next()
          break
      }
    },
    handleScroll (e) {
      if (this.sliding || Math.abs(e.deltaY) <= 2 && Math.abs(e.deltaX) <= 2) return
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        if (this.isFirefox) {
          if (e.detail < 0) {
            this.prev()
          } else {
            this.next()
          }
        } else {
          if (e.deltaY !== 0) {
            if (e.deltaY > 0) {
              this.next()
            } else {
              this.prev()
            }
          }
        }
      } else {
        if (this.isFirefox) {
          if (e.detail < 0) {
            this.prev()
          } else {
            this.next()
          }
        } else {
          if (e.deltaX !== 0) {
            if (e.deltaX > 0) {
              this.next()
            } else {
              this.prev()
            }
          }
        }
      }
    },
    calcBoundsMax () {
      if (this.platform === 'mobile') {
        return Math.floor(-this.$refs.wrapper.offsetHeight + (window.innerHeight * 0.8))
      } else {
        return Math.floor(this.snaps[this.items.length - 1] - 1)
      }
    },
    calcSnaps () {
      if (this.platform === 'mobile') {
        // this.items.map((item, key) => {
        //   item.boundings = this.$refs.item[key].getBoundingClientRect()
        // })
        this.snaps = []
        for (var i = 0; i < this.items.length; i++) {
          this.snaps.push(Math.ceil(-(i * window.innerHeight * 0.70)))
        }
      } else {
        this.snaps = []
        for (var i = 0; i < this.items.length; i++) {
          this.snaps.push(Math.ceil(-(i * (window.innerWidth * 0.65))))
        }
        this.items.map((item, key) => {
          item.boundings = this.$refs.item[key].getBoundingClientRect()
        })

        // this.itemsTmp = this.itemsActive
        // this.itemsActive = this.items
        //
        // this.$nextTick(() => {
        //   // this.items.map((item, key) => {
        //   //   item.boundings = this.$refs.item[key].getBoundingClientRect()
        //   // })
        //
        //   this.$nextTick(() => {
        //     this.itemsActive = this.itemsTmp
        //     this.itemsTmp = []
        //   })
        // })
      }
    },
    setTitle () {
      this.$refs.title.innerHTML = this.itemsActive[this.currentIndex].title
      new SplitText(this.$refs.title, { type: 'lines words', linesClass: 'lines', wordsClass: 'words' })
    },
    hideTitle () {
      this.$refs.titleContainer.classList.add('down')
    },
    showTitle () {
      this.$refs.titleContainer.classList.remove('down')
    },
    setColor () {
      this.bgc.backgroundColor = this.itemsActive[this.currentIndex].backgroundColor
      this.bgc.backgroundColor = this.itemsActive[this.currentIndex].backgroundColor
    },
    goTo (key, velocity = undefined, duration = 1.2) {
      this.sliding = true

      if (this.glxp) {
        if (velocity !== undefined) {
          this.velocity = key === this.currentIndex ? 0 : velocity
        } else {
          this.velocity += (key - this.currentIndex) * 0.15
        }
      }
      this.hideTitle()
      this.currentIndex = key
      TweenMax.to(this.draggable.target, duration, {
        x: this.snaps[key],
        y: 0,
        onStart: () => {
          this.setColor()
          setTimeout(() => {
            this.setTitle()
          }, 200)
        },
        onComplete: () => {
          this.showTitle()
          this.sliding = false
        },
        onUpdate: () => {
          this.draggable.update()
        }
      })
      if (this.progressDraggable) {
        TweenMax.to(this.progressDraggable.target, duration, {
          x: `${(key / this.itemsActive.length) * window.innerWidth * 0.4}`,
          onUpdate: () => {
            this.progressDraggable.update()
          }
        })
      }
    },
    prev () {
      if (this.currentIndex > 0) {
        this.goTo(this.currentIndex - 1)
      }
    },
    next () {
      if (this.currentIndex < this.itemsActive.length - 1) {
        this.goTo(this.currentIndex + 1)
      }
    },
    filter (key, value = undefined) {
      const itemsActive = []
      if (value !== undefined) {
        this.items.forEach(item => {
          if (item[key].includes(value)) {
            itemsActive.push(item)
            this.setVisibility(item.id, true)
          } else {
            this.setVisibility(item.id, false)
          }
        })
        this.itemsActive = itemsActive
      } else {
        this.itemsActive = this.items
        this.items.forEach(item => {
          this.setVisibility(item.id, true)
        })
      }

      if (this.platform === 'mobile') {
        this.draggable.applyBounds({
          minY: 0,
          maxY: this.snaps[this.itemsActive.length - 1] - 1
        })
      } else {
        this.draggable.applyBounds({
          minX: 0,
          maxX: this.snaps[this.itemsActive.length - 1] - 1
        })
        this.progressDraggable.applyBounds({
          minX: 0,
          maxX: (this.$refs['progress-container'].offsetWidth * (this.itemsActive.length - 1) / this.itemsActive.length)
        })
      }

      this.goTo(0, 0.15)
    },
    initWebgl () {
      this.glxp = WebglManager.getScene('partners')
      this.glxp.imageSize = window.innerWidth / window.innerHeight / 2 * this.glxp.fovFactor

      // this.fovFactor = window.innerHeight / window.innerWidth
      this.fovFactor = 1

      this.items.forEach((item, key) => {
        this.glxp.addImage(`image-${key}`, this.getImageUrl(item.image, 'cover-desktop'))
      })

      WebglManager.loadScene('partners')
      WebglManager.activate('partners')
      this.$nextTick(() => {
        this.$nextTick(() => {
          WebglManager.recomputeBounds()
        })
      })
      WebglManager.setStyle({
        zIndex: 1,
        pointerEvents: 'none'
      })

      if (this.glxp.loaded) {
        this.webglEnabled = true
      } else {
        this.glxp.on('loaded', () => {
          this.webglEnabled = true
        })
      }
    },

    setTranslate (key, x, y) {
      if (this.glxp) {
        this.glxp.setTranslate(key, x / window.innerWidth, y / window.innerHeight)
      }
    },

    setOpacity (key, opacity) {
      if (this.glxp) {
        this.glxp.setOpacity(key, opacity)
      }
    },

    setVisibility (id, value) {
      if (this.glxp) {
        this.glxp.setVisibility(id, value)
      }
    },

    update () {
      if (this.glxp) {
        if (window.innerWidth < 813) {
          this.glxp.imageSize = window.innerWidth / window.innerHeight * this.glxp.fovFactor
        } else {
          this.glxp.imageSize = window.innerWidth / window.innerHeight / 2 * this.glxp.fovFactor
        }

        this.itemsActive.forEach((item, key) => {
          if (window.innerWidth < 813) {
            this.setTranslate(item.id, (this.draggable.x + -this.snaps[key]) * this.fovFactor, this.items[key].boundings.y - (window.innerHeight * 0.25))
          } else {
            this.setTranslate(item.id, (this.draggable.x + -this.snaps[key]) * this.fovFactor, this.items[key].boundings.y - (window.innerHeight * 0.05))
          }

          // this.setTranslate(item.id, (this.draggable.x + -this.snaps[key]) * this.fovFactor, 0)
        })
      }

      if (this.progress) {
        const progressPercentage = Math.min(100, Math.max(0, Math.abs(Math.round(this.progressDraggable.x / this.progressDraggable.maxX * 100 * 100) / 100)))
        // console.log(progressPercentage)
        // TweenMax.set(this.draggable.target, { x: `-${Math.floor(this.progressDraggable.x / (this.progressDraggable.maxX / (this.itemsActive.length - 1) * this.itemsActive.length) * (this.$refs.wrapper.offsetWidth - this.$refs.cursor.offsetWidth))}px` })
        // TweenMax.set(this.draggable.target, { x: `-${Math.floor((this.progressDraggable.x - this.$refs.cursor.offsetWidth) / (this.progressDraggable.maxX) * (this.$refs.wrapper.offsetWidth - window.innerWidth * 0.25))}px` })
        // console.log(this.progressDraggable.x, this.progressDraggable.maxX, this.progressDraggable.x / this.progressDraggable.maxX, progressPercentage)
        TweenMax.set(this.draggable.target, { x: Math.floor(progressPercentage * this.draggable.minX / 100) })
        this.draggable.update()
      } else {
        const sliderPercentage = Math.min(100, Math.max(0, Math.abs(Math.round(this.draggable.x / this.draggable.minX * 100 * 100) / 100)))
        // console.log(sliderPercentage)
        // TweenMax.set(this.progressDraggable.target, { x: Math.floor((this.draggable.x / (this.draggable.minX + window.innerWidth * 0.25)) * (this.$refs.progress.offsetWidth - this.$refs.cursor.offsetWidth)) })
        // console.log(this.draggable.x, this.draggable.minX, this.draggable.x / this.draggable.minX, sliderPercentage)
        TweenMax.set(this.progressDraggable.target, { x: Math.floor(sliderPercentage * this.progressDraggable.maxX / 100) })
        this.progressDraggable.update()
      }
      // 0 -1139.125 528 264 1339 200.85
      // => 0
      // -803.4 -1139.125 528 264 1339 200.85
      //  => 264

      if (this.glxp) {
        this.glxp.scrollVelocity[0] = this.velocity
        this.velocity *= 0.9
      }
    },
    resize () {
      const currentIndex = this.currentIndex
      this.goTo(0, 0, 0)
      this.calcSnaps()

      this.height = window.innerHeight
      this.width = window.innerWidth

      this.$nextTick(() => {
        if (this.platform === 'mobile') {
          this.draggable.applyBounds({
            minY: 0,
            maxY: this.calcBoundsMax()
          })
        } else {
          this.draggable.applyBounds({
            minX: 0,
            maxX: this.calcBoundsMax()
          })
          this.progressDraggable.applyBounds({
            minX: 0,
            maxX: (this.$refs['progress-container'].offsetWidth * (this.itemsActive.length - 1) / this.itemsActive.length)
          })
          // this.$nextTick(() => {
          //   this.glxp.reset()
          //   this.glxp = null
          //   WebglManager.desactivate('partners')
          //   this.$nextTick(() => {
          //     this.initWebgl()
          //   })
          // })
        }
      })

      this.$nextTick(() => {
        this.goTo(currentIndex, 0, 0)
      })
    }
  }

}
